import { apiSlice } from "../../app/apiSlice";
import { withDefaultMeta } from "../../util/withDefaultMeta";

export const videoCategoriesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => {
    const query = withDefaultMeta(builder.query);
    const mutation = withDefaultMeta(builder.mutation);

    return {
      getCategories: query({
        query: () => "/categories",
        providesTags: ["VideoCategory"],
        meta: { requiresAuth: false },
      }),

      createCategory: mutation({
        query: (data) => ({
          url: "/categories",
          method: "POST",
          body: data,
        }),
        invalidatesTags: ["VideoCategory"],
      }),

      updateCategory: mutation({
        query: ({ id, ...data }) => ({
          url: `/categories/${id}`,
          method: "PUT",
          body: data,
        }),
        invalidatesTags: ["VideoCategory"],
      }),

      getCategoryById: builder.query({
        query: (id) => `/categories/${id}`,
        providesTags: ["VideoCategory"],
        meta: { requiresAuth: false },
      }),

      reorderCategories: mutation({
        query: (orderedIds) => ({
          url: "/categories/reorder",
          method: "PUT",
          body: { orderedIds },
        }),
        invalidatesTags: ["VideoCategory"],
      }),

      deleteCategory: mutation({
        query: ({ categoryId }) => ({
          url: `/categories/${categoryId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["VideoCategory"],
      }),
    };
  },
});

export const {
  useReorderCategoriesMutation,
  useGetCategoryByIdQuery,
  useGetCategoriesQuery,
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
} = videoCategoriesApiSlice;
